import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "图片加载中...", -1);
const _hoisted_2 = ["src", "onload"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SkeletonImage = _resolveComponent("SkeletonImage");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["img-place", {
      'img-place-noshow': _ctx.isActive
    }])
  }, [_hoisted_1, _createVNode(_component_SkeletonImage, {
    active: true
  })], 2), [[_vShow, !_ctx.isActive]]), _withDirectives(_createElementVNode("img", {
    class: "img-content",
    src: _ctx.path,
    alt: "",
    onload: res => _ctx.imgOnload(res)
  }, null, 8, _hoisted_2), [[_vShow, _ctx.isActive]])], 64);
}